import {AxiosError} from 'axios';
import {
  UserGroupAccessConfigurationResponse
} from 'web-library/models/UserGroupAccessConfiguration/UserGroupAccessConfiguration';
import {GET_DATA_ARCHIVAL_FILTER_ARCHIVAL_LEVEL_URL} from '../../constants/apiUrls';
import {GET_DATA_ARCHIVAL_FILTER_ARCHIVAL_LEVEL} from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import {useCustomQuery} from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

interface Input {
  onSuccess?: (res: UserGroupAccessConfigurationResponse) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const useGetDataArchivalFilterArchivalLevel = ({onError, onSuccess}: Input) => {
  const getDataArchivalFilterArchivalLevel = async () => {
    const res = await axiosClient.get<UserGroupAccessConfigurationResponse>(
        GET_DATA_ARCHIVAL_FILTER_ARCHIVAL_LEVEL_URL
    );

    return res.data;
  };

  return useCustomQuery(
      [GET_DATA_ARCHIVAL_FILTER_ARCHIVAL_LEVEL],
      getDataArchivalFilterArchivalLevel,
      {
        onSuccess,
        onError,
      }
  );
};
